__turbopack_context__.v({
  "accept": "ConsentBanner-module-scss-module__cdmHbq__accept",
  "actions": "ConsentBanner-module-scss-module__cdmHbq__actions",
  "banner": "ConsentBanner-module-scss-module__cdmHbq__banner",
  "body": "ConsentBanner-module-scss-module__cdmHbq__body",
  "inner": "ConsentBanner-module-scss-module__cdmHbq__inner",
  "link": "ConsentBanner-module-scss-module__cdmHbq__link",
  "reject": "ConsentBanner-module-scss-module__cdmHbq__reject",
  "text": "ConsentBanner-module-scss-module__cdmHbq__text",
  "title": "ConsentBanner-module-scss-module__cdmHbq__title",
});
